import React, { useState } from 'react';
import cloneDeep from 'lodash';
import moment from 'moment';
import { DatePicker } from 'antd';


interface PropsType {
  value?: any;
  onChange?: any;
  format?: string;
  disabledDate?: any;
  previousDisabled?: any;
}

const DateRangePicker:React.FC<PropsType> = (props:any) => {
  const { value, onChange, format = 'YYYY-MM-DD', showTime = false, disabledDate, previousDisabled = false } = props || {};

  const [startDate, setStartDate] = useState<any>(null);

  const newValue:any = cloneDeep(value || null);
  if(value?.length && moment(value[0], format).isValid() && moment(value[1], format).isValid()){
    newValue[0] = moment(value[0]);
    newValue[1] = moment(value[1]);
  }
  const handlePickerChange = (date:any, dateStrings: any) => {
    onChange && onChange(!date ? null : dateStrings);
    setStartDate(null);
  }

  const handleCalendarChange = (dates:any) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    }
  }

  return (
    <DatePicker.RangePicker
      showTime={showTime}
      value={newValue}
      format={format}
      disabledDate={(current:any) => {
        return (previousDisabled ? current && current < moment().startOf('day') : false) || (disabledDate && disabledDate(current, startDate));
      }}
      onChange={handlePickerChange}
      onCalendarChange={handleCalendarChange}
    />
  );
}

export default DateRangePicker;